"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.faqSchema = void 0;
const joi_1 = __importDefault(require("joi"));
const GenericValidator_1 = __importDefault(require("../../shared/validators/GenericValidator"));
exports.faqSchema = joi_1.default.object({
    question: joi_1.default.string().required(),
    answer: joi_1.default.string().required(),
    isCustom: joi_1.default.boolean(),
    index: joi_1.default.number().required(),
});
class FaqValidator extends GenericValidator_1.default {
    validate(faq) {
        super.validate(faq, 'IFaq', exports.faqSchema);
    }
}
exports.default = FaqValidator;
